import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ContractService } from '../../../_services';
import { ContractIfrsBase } from "./base/contract-ifrs.base";
import { IContract, IStore, IIdName, IIdNameGeneric } from '../../../_entities';
import { StringTool } from "../../../core/tools/index";
import * as moment from 'moment';

@Component({
	selector: 'd-rent-deductions',
	template: require('./d-rent-deductions.component.html'),
	encapsulation: ViewEncapsulation.None
})
export class RentDeductionsComponent extends ContractIfrsBase implements OnInit {

	constructor(contractService: ContractService) {
		super(contractService);
	}

	get rentAndCharges() {
		if (this.contract)
			return this.contract.rentAndCharges;
		return null;
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/d-rent-deductions.component.ts